import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/sensitive/getList',
        method: 'post',
        data: data
    })
}
export function getWordInfo(data) {
    return request({
        url: '/backend/sensitive/getWordInfo',
        method: 'post',
        data: data
    })
}
export function createWord(data) {
    return request({
        url: '/backend/sensitive/createWord',
        method: 'post',
        data: data
    })
}
export function updateWord(data) {
    return request({
        url: '/backend/sensitive/updateWord',
        method: 'post',
        data: data
    })
}
export function deleteWord(data) {
    return request({
        url: '/backend/sensitive/deleteWord',
        method: 'post',
        data: data
    })
}
export function batchCreateWord(data) {
    return request({
        url: '/backend/sensitive/batchCreateWord',
        method: 'post',
        data: data
    })
}